import { IVillagesOffersSummarySchema } from '../../../../node/repositories/countryside-search/entities/offers_summary/VillagesOffersSummarySchema';
import { ISearchResultMetricsSchema } from '../../../repositories/countryside-search/entities/search_result_metrics/SearchResultMetricsSchema';

export const prepareSearchResultMetrics = (
  villageListSummary: IVillagesOffersSummarySchema | null,
  totalCount: number | null | undefined,
): ISearchResultMetricsSchema | null => {
  if (!villageListSummary) {
    return null;
  }

  const { cottage, land, townhouse, house } = villageListSummary;

  return {
    /** Средняя площадь коттеджа, кв. м. **/
    avgCottageArea: getValue(cottage.avgArea),
    /** Средняя цена коттеджа **/
    avgCottagePrice: getValue(cottage.avgPrice),
    /** Средняя цена коттеджа за кв. м. **/
    avgCottagePricePerSqm: getValue(cottage.avgPricePerSqm),
    /** Количество коттеджей **/
    cottagesCount: getValue(cottage.count),
    /** Максимальная площадь коттеджа, кв. м. **/
    maxCottageArea: getValue(cottage.maxArea),
    /** Максимальная цена коттеджа **/
    maxCottagePrice: getValue(cottage.maxPrice),
    /** Минимальная площадь коттеджа, кв. м. **/
    minCottageArea: getValue(cottage.minArea),
    /** Минимальная цена коттеджа **/
    minCottagePrice: getValue(cottage.minPrice),

    /** Средняя площадь малоэтажного дома, кв. м. **/
    avgHouseArea: getValue(house.avgArea),
    /** Средняя цена малоэтажного дома **/
    avgHousePrice: getValue(house.avgPrice),
    /** Средняя цена малоэтажного дома за кв. м. **/
    avgHousePricePerSqm: getValue(house.avgPricePerSqm),
    /** Количество малоэтажных домов **/
    housesCount: getValue(house.count),
    /** Максимальная площадь малоэтажного дома, кв. м. **/
    maxHouseArea: getValue(house.maxArea),
    /** Максимальная цена малоэтажного дома **/
    maxHousePrice: getValue(house.maxPrice),
    /** Минимальная площадь малоэтажного дома, кв. м. **/
    minHouseArea: getValue(house.minArea),
    /** Минимальная цена малоэтажного дома **/
    minHousePrice: getValue(house.minPrice),

    /** Средняя площадь земли, сот. **/
    avgLandArea: getValue(land.avgArea),
    /** Средняя цена участка земли **/
    avgLandPlotPrice: getValue(land.avgPrice),
    /** Средняя цена за сотку участка земли **/
    avgLandPlotPricePerAre: getValue(land.avgPricePerAre),
    /** Количество земельных участков **/
    landPlotsCount: getValue(land.count),
    /** Максимальная площадь земли, сот. **/
    maxLandArea: getValue(land.maxArea),
    /** Максимальная цена участка земли **/
    maxLandPlotPrice: getValue(land.maxPrice),
    /** Минимальная площадь земли, сот. **/
    minLandArea: getValue(land.minArea),
    /** Минимальная цена участка земли **/
    minLandPlotPrice: getValue(land.minPrice),

    /** Средняя площадь таунхауса, кв. м. **/
    avgTownhouseArea: getValue(townhouse.avgArea),
    /** Средняя цена таунхауса **/
    avgTownhousePrice: getValue(townhouse.avgPrice),
    /** Средняя цена таунхауса за кв. м. **/
    avgTownhousePricePerSqm: getValue(townhouse.avgPricePerSqm),
    /** Максимальная площадь таунхауса, кв. м. **/
    maxTownhouseArea: getValue(townhouse.maxArea),
    /** Максимальная цена таунхауса **/
    maxTownhousePrice: getValue(townhouse.maxPrice),
    /** Минимальная площадь таунхауса, кв. м. **/
    minTownhouseArea: getValue(townhouse.minArea),
    /** Минимальная цена таунхауса **/
    minTownhousePrice: getValue(townhouse.minPrice),
    /** Количество таунхаусов **/
    townhousesCount: getValue(townhouse.count),

    /** Количество объявлений **/
    offersCount: getValue(totalCount),
  };
};

function getValue<T>(value: T | null | undefined) {
  return value ?? undefined;
}
